// Groups catalog products that share a base name, turning trailing size/strength
// (e.g. "10mg", "500mg", "3ml") into selectable variants.
const SIZE_RE = /\s*[·-]?\s*(\d+(?:\.\d+)?)\s*(mg|mcg|ml|iu|g)\b\.?$/i;

export function parseVariant(name = "") {
  const m = name.match(SIZE_RE);
  if (!m) return { base: name.trim(), size: null, sizeValue: null, unit: null };
  const base = name.slice(0, m.index).trim();
  return {
    base: base || name.trim(),
    size: `${m[1]}${m[2].toLowerCase()}`,
    sizeValue: parseFloat(m[1]),
    unit: m[2].toLowerCase(),
  };
}

export function decorateVariant(p) {
  const { base, size, sizeValue, unit } = parseVariant(p.name || "");
  return { ...p, _base: base, _size: size, _sizeValue: sizeValue, _unit: unit };
}

export function groupProducts(products = []) {
  const map = new Map();
  for (const p of products) {
    const d = decorateVariant(p);
    const key = d._base.toLowerCase();
    if (!map.has(key)) map.set(key, { base: d._base, variants: [] });
    map.get(key).variants.push(d);
  }
  const groups = [];
  for (const g of map.values()) {
    g.variants.sort((a, b) => (a._sizeValue ?? 0) - (b._sizeValue ?? 0));
    g.minPrice = Math.min(...g.variants.map((v) => v.price ?? 0));
    g.hasVariants = g.variants.length > 1 && g.variants.every((v) => v._size);
    g.rep = g.variants[0];
    groups.push(g);
  }
  return groups;
}

// Returns the sorted sibling variants (same base) for a given product from a flat list.
export function siblingsFor(product, products = []) {
  if (!product) return [];
  const base = parseVariant(product.name || "").base.toLowerCase();
  return products
    .map(decorateVariant)
    .filter((p) => p._base.toLowerCase() === base && p._size)
    .sort((a, b) => (a._sizeValue ?? 0) - (b._sizeValue ?? 0));
}
